var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.getClasses(),attrs:{"title":`${_vm.capitalizedName}`,"width":"1em","height":"1em"}},[_c('use',{attrs:{"xlink:href":`${_vm.themeUrl}/dist/images/spritemap.svg?v=1#sprite-${_vm.name}`,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }